export enum SortCode {
  PriceAsc = 'price-asc',
  PriceAscB2c = 'price-asc-b2c',
  PriceAscB2b = 'price-asc-b2b',
  PriceDesc = 'price-desc',
  PriceDescB2c = 'price-desc-b2c',
  PriceDescB2b = 'price-desc-b2b',
  MonthlyAsc = 'monthly-asc',
  MonthlyAscB2c = 'monthly-asc-b2c',
  MonthlyAscB2b = 'monthly-asc-b2b',
  MonthlyDesc = 'monthly-desc',
  MonthlyDescB2c = 'monthly-desc-b2c',
  MonthlyDescB2b = 'monthly-desc-b2b',
  NameAsc = 'name-asc',
  NameDesc = 'name-desc',
}
